import { finishTarget, reviewKey } from '../../../lib/site-review';
import { boundConversationFor, closeSitePane, expectSiteChat, type SitePaneRequest } from '../../../lib/site-edit-store';
import { useSiteChat } from './use-site-edit';
import { SiteReviewFrame } from './SiteReviewFrame';

/**
 * A Symphony site's LIVE preview beside its chat, on a computer (contract §1 CHAT): opened by Edit and by the chat's
 * "Preview site" link, drawn by FloatingChat in the split the chat file pane uses (`lib/use-site-pane.ts` decides
 * when). The review runs here; Finish SENDS its message to the chat beside it (else the site's bound chat, else a new one).
 */
export function SitePreviewPane({ request }: { request: SitePaneRequest }) {
  const { send, sendText } = useSiteChat({ workspaceId: request.workspaceId, workspaceName: '', website: null, siteRef: request.previewUrl });
  return (
    <SiteReviewFrame
      previewUrl={request.previewUrl}
      reviewKey={reviewKey(request.previewUrl, request.conversationId, request.workspaceId)}
      layout="pane"
      conversationId={request.conversationId}
      onFinish={(message) => {
        const target = finishTarget(request.conversationId, boundConversationFor(request.workspaceId, request.previewUrl));
        if (target.kind === 'new') expectSiteChat(request.workspaceId, request.previewUrl);
        const conversationId = target.kind === 'existing' ? target.conversationId : null;
        sendText(message, conversationId);
        return conversationId;
      }}
      onClose={closeSitePane}
      onAskRepublish={() => send({ key: 'siteReview.republishMessage', values: { url: request.previewUrl } }, request.conversationId)}
    />
  );
}
